import { StateCreator } from 'zustand'
import useEventsSearch from '../../shared/hooks/useEventsSearch'
import { EventsFilteringStore } from './useEventsFilteringStore'

export type SortStoreState = {
  currentSort?: string | undefined,
}

export type SortStoreActions = {
  setCurrentSort: (newSort: string | undefined) => void,
}

export type SortSlice = SortStoreState & SortStoreActions

export const createSortSlice: StateCreator<
  EventsFilteringStore,
  [],
  [],
  SortSlice
> = (set, get) => ({
  currentSort: undefined,
  setCurrentSort: (newSort) => {
    set({ currentSort: newSort })
    useEventsSearch({
      searchTerm: get().searchTerm,
      currentSort: newSort,
      setLoading: get().setLoading
    })
  }
})